
export default {
    name: "FullscreenButton",
    props: {
        fullscreenEnabled: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
